export const getTotalMoney = (data) => {
    let cont = 0;
    data.forEach(doc => {
        cont += Number(doc.price)
    })
    cont = Number(cont);

    return cont;
}